<template>
  <v-modal
      title=""
      :show="show"
      @close="$emit('close')"
      size="lg"
      buttonClose="true"
  >
    <ui-spinner v-if="loading.view"></ui-spinner>
    <template v-else>
      <div class="row form-row">
        <div class="col-lg-3">
          <div class="form-group">
            <label for="" class="form-label">Estación *</label>
            <select v-model="idEstacion" class="form-control form-control-sm">
              <option
                  v-for="item in containers.estaciones"
                  :key="item.idEstacion"
                  :value="item.idEstacion"
              >
                {{ item.nombre }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label for="" class="form-label">Hora *</label>
            <div>
              <UiInputTime
                  v-model="time"
                  class="form-control form-control-sm"
              />
            </div>
          </div>
          <div class="text-right">
            <button
                class="btn btn-sm btn-outline-success"
                :disabled="loading.crud"
                @click="onNew"
            >
              Nuevo
            </button>
            <button
                class="ml-2 btn btn-sm btn-primary"
                :disabled="loading.crud"
                @click="onSave"
            >
              Guardar
            </button>
          </div>
        </div>
        <div class="col-lg-9">
          <div class="table-responsive">
            <table class="table table-bordered table-sm table-hover">
              <thead class="table-secondary">
              <tr class="text-center align-middle">
                <th style="width: 80px"></th>
                <th>Estación</th>
                <th>Hora</th>
                <th>UC</th>
                <th>UM</th>
              </tr>
              </thead>
              <tbody>
              <tr
                  v-for="item in containers.horas"
                  :key="item.idTrenEstacion"
                  class="align-middle text-center"
              >
                <td>
                  <template v-if="item.origen != 0">
                    <button
                        class="btn btn-xs btn-icon btn-light-warning"
                        @click="onEdit(item)"
                    >
                      <span class="fa fa-fw fa-pencil-alt"></span>
                    </button>
                    <button
                        class="btn btn-xs btn-icon btn-light-danger ml-2"
                        @click="onDelete(item)"
                    >
                      <span class="fa fa-fw fa-trash-alt"></span>
                    </button>
                  </template>
                </td>
                <td>{{ item.estacion }}</td>
                <td>{{ $formatter("time", item.hora) }}</td>
                <td>{{ item.usuarioCreador }}</td>
                <td>{{ item.usuarioModif }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </template>
  </v-modal>
</template>
<script>
const vModal = () =>
    import(/* webpackChunkName: "ui-modal" */ "@/components/vModal");

const UiInputTime = () => import("@/components/InputTime2");

export default {
  components: {
    vModal,
    UiInputTime,
  },
  props: ["show", "tren", "trenServicio"],
  data() {
    return {
      idEstacion: "",
      time: "",
      loading: {
        view: true,
        crud: false,
      },
      containers: {
        id: null,
        horas: [],
        estaciones: [],
      },
    };
  },
  async created() {
    let vm = this;

    let response = await vm.axios.get(
        `/mantenimiento/trenes/${vm.trenServicio.idTrenServicio}/numeros/${vm.tren.idTren}/horas`
    );

    vm.containers.horas = response.data.content.horas;
    vm.containers.estaciones = response.data.content.estaciones;

    vm.loading.view = false;
  },
  methods: {
    onSave() {
      let vm = this;
      let fd = {
        idEstacion: vm.idEstacion,
        time: (vm.time || "").trim(),
        _method: "POST",
      };

      if (!(fd.idEstacion && fd.time)) {
        return vm.$swal.fire(
            "",
            "Completa los campos obligatorios (*)",
            "warning"
        );
      }

      vm.loading.crud = true;

      let endpoint = `/mantenimiento/trenes/${vm.trenServicio.idTrenServicio}/numeros/${vm.tren.idTren}/horas`;

      if (vm.containers.id) {
        endpoint = `/mantenimiento/trenes/${vm.trenServicio.idTrenServicio}/numeros/${vm.tren.idTren}/horas/${vm.containers.id}`;
        fd._method = "PUT";
      }

      vm.axios
          .post(endpoint, fd)
          .then((response) => {
            if (vm.containers.id) {
              let findRow = vm.containers.horas.find(
                  (item) => item.idTrenEstacion == vm.containers.id
              );

              findRow.estacion = vm.containers.estaciones.find(
                  (item) => item.idEstacion == fd.idEstacion
              ).nombre;
              findRow.idEstacion = fd.idEstacion;
              findRow.hora = fd.time + ':00';
              findRow.usuarioModif = vm.$store.state.user.codigo;
            } else {
              vm.containers.horas.push({
                estacion: vm.containers.estaciones.find(
                    (item) => item.idEstacion == fd.idEstacion
                ).nombre,
                idEstacion: fd.idEstacion,
                hora: fd.time + ':00',
                idTrenEstacion: response.data.content.id,
                usuarioCreador: vm.$store.state.user.codigo,
              });

              vm.containers.id = response.data.content.id;
            }

            vm.$toast.fire(response.data.message, "", "success");
          })
          .catch((error) => {
            vm.$toast.fire(error.response.data.message, "", "error");
          })
          .finally(() => {
            vm.loading.crud = false;
          });
    },
    onEdit(pItem) {
      this.idEstacion = pItem.idEstacion;
      this.time = this.$dayjs(pItem.hora, "HH:mm:ss").format("HH:mm");
      this.containers.id = pItem.idTrenEstacion;
    },
    async onDelete(pItem) {
      let vm = this;
      let response = await vm.$confirm.fire(
          "",
          "¿Seguro que desea eliminar este item?"
      );

      if (response.value) {
        vm.loading.crud = true;

        vm.axios
            .delete(
                `/mantenimiento/trenes/${vm.trenServicio.idTrenServicio}/numeros/${vm.tren.idTren}/horas/${pItem.idTrenEstacion}`
            )
            .then((response) => {
              let tempRegistros = [...vm.containers.horas];
              vm.containers.horas = tempRegistros.filter(
                  (item) =>
                      item.idTrenEstacion !=
                      pItem.idTrenEstacion
              );
              vm.onNew();
            })
            .catch((error) => {
              vm.$toast.fire(error.response.data.message, "", "error");
            })
            .finally(() => {
              vm.loading.crud = false;
            });
      }
    },
    onNew() {
      let vm = this;
      vm.idEstacion = "";
      vm.time = "";
      vm.containers.id = null;
    },
  },
};
</script>
